import "./_Orders.scss";
import "./_OrdersMobile.scss";
import _OrderSideNav from "./_OrderSideNav/_OrderSideNav";
import { useState, useEffect } from "react";
import _PendingPayment from "./_OrderContent/_PendingPayment/_PendingPayment";
import _PartialPayment from "./_OrderContent/_PartialPayment/_PartialPayment";
import _Paid from "./_OrderContent/_Paid/_Paid";
import _ReadyToShip from "./_OrderContent/_ReadyToShip/_ReadyToShip";
import _Shipped from "./_OrderContent/_Shipped/_Shipped";
import _Completed from "./_OrderContent/_Completed/_Completed";
import _Cancelled from "./_OrderContent/_Cancelled/_Cancelled";
import _Refunded from "./_OrderContent/_Refunded/_Refunded";
import { useAppContext } from "../../../../Components/AppProvider";
import _Unpaid from "./_OrderContent/_Unpaid/_Unpaid";
import { setRedirect } from "../../utils/_redirect";
import _Declined from "./_OrderContent/_Declined/_Declined";
function _Orders({ side = 0 }) {
  const sidenavstructure = [
    "UNPAID ORDERS",
    "PENDING APPROVALS",
    "PARTIALLY PAID",
    "FULLY PAID",
    "READY TO SHIP",
    "SHIPPED",
    "COMPLETED",
    "DECLINED",
    "CANCELLED",
    "REFUNDED",
  ];
  const content = [
    _Unpaid,
    _PendingPayment,
    _PartialPayment,
    _Paid,
    _ReadyToShip,
    _Shipped,
    _Completed,
    _Declined,
    _Cancelled,
    _Refunded,
  ];

  const { statusCountList, setStatusCountList, isCountListUpdate } =
    useAppContext();
  const [activeSideNav, setActiveSideNav] = useState(side); // Usually start from 0

  const ActiveComponent = content[activeSideNav]; // get the component

  useEffect(() => {
    let intervalId;

    const fetchCounts = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/counts`
        );
        if (!res.ok) throw new Error("Failed to fetch counts");

        const data = await res.json();
        setStatusCountList({
          unpaidCount: data.unpaidCount || 0,
          pendingCount: data.pendingCount || 0,
          partialCount: data.partialCount || 0,
          paidCount: data.paidCount || 0,
          ready2shipCount: data.ready2shipCount || 0,
          shippedCount: data.shippedCount || 0,
          completedCount: data.completedCount || 0,
          declinedCount: data.declinedCount || 0,
          cancelledCount: data.cancelledCount || 0,
          refundedCount: data.refundedCount || 0,
        });
        ////console.log("data from backend:", data);
      } catch (err) {
        console.error("Error loading counts:", err);
      }
    };

    fetchCounts(); // run immediately

    intervalId = setInterval(fetchCounts, 10000); // refresh every 10s

    return () => clearInterval(intervalId); // cleanup
  }, [isCountListUpdate]);

  // if you want to see updated state every time it changes
  useEffect(() => {
    ////console.log("statusCountList updated: ", statusCountList);
  }, [statusCountList]);
  return (
    <>
      {" "}
      <section className="admin-order-container">
        <_OrderSideNav
          sidenavstructure={sidenavstructure}
          activeSideNav={activeSideNav}
          setActiveSideNav={setActiveSideNav}
          statusCountList={statusCountList}
        />
        <ActiveComponent />
      </section>
    </>
  );
}
export default _Orders;
